import {useMemo, useState} from 'react'

import {useConfigurationContext} from '../../configuration/useConfigurationContext'
import {
  isOrderIntakeFieldStepFactory,
  OrderIntakeStep,
  OrderIntakeStepFactories
} from '../../orderIntake/wizard/types'

export const useOrderIntakeSteps = <T, C>(
  factories: OrderIntakeStepFactories<T, C>,
  stepConfiguration: C
) => {
  const configuration = useConfigurationContext()
  return useMemo(() => {
    return factories
      .map((i) => {
        // do we need that? so far i've skipped that
        if (isOrderIntakeFieldStepFactory(i)) {
          return i.factory({fieldConfiguration: configuration, stepConfiguration, value: 'some'})
        } else {
          return i.factory({fieldConfiguration: configuration, stepConfiguration})
        }
      })
      .filter((i) => i.isEnabled) as unknown as OrderIntakeStep<T>[]
  }, [configuration, stepConfiguration, factories])
}

export const useOrderIntakeStepper = <T = string>(steps: OrderIntakeStep<T>[]) => {
  const [currentStepIndex, setCurrentStep] = useState(0)
  const currentStep = useMemo(() => steps[currentStepIndex], [steps, currentStepIndex])

  return useMemo(
    () => ({
      currentStepIndex,
      currentStep,
      setCurrentStep,
      goToNextStep: () =>
        setCurrentStep((current) => (current < steps.length - 1 ? current + 1 : current)),
      goToPreviousStep: () => setCurrentStep((current) => (current > 0 ? current - 1 : current))
    }),
    [currentStep, currentStepIndex, steps]
  )
}
